import { render, staticRenderFns } from "./invite_call.vue?vue&type=template&id=4ad8f142"
import script from "./invite_call.vue?vue&type=script&lang=ts"
export * from "./invite_call.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports